// src/Models/ticketAssignmentModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme for Ticket Assignments.
// -----------------------------------------------------------------------------

export class TicketAssignmentModel {
  static toFrontend(data) {
    if (!data) return null;
    const uid = data.userId ?? data.userID ?? data.UserId ?? data.UserID ?? data.id ?? 0;
    const assignerId = data.assignedBy ?? data.AssignedBy ?? 0;

    return {
      assignmentID: data.assignmentId ?? data.assignmentID ?? data.AssignmentId ?? data.AssignmentID ?? data.id ?? 0,
      ticketID: data.ticketId ?? data.ticketID ?? data.TicketId ?? data.TicketID ?? 0,
      userID: uid,
      assignedBy: assignerId,
      assignedDttm: data.assignedDttm || data.AssignedDttm || null,
      unassignedDttm: data.unassignedDttm || data.UnassignedDttm || null,
      isCurrentFlag: data.isCurrentFlag !== undefined
        ? Boolean(data.isCurrentFlag)
        : (data.IsCurrentFlag !== undefined ? Boolean(data.IsCurrentFlag) : true),
      userName: data.userName || data.user_Name || data.UserName || data.fullName || (uid ? `User ${uid}` : ''),
      assignedByName: data.assignedByName || data.assigned_By_Name || data.AssignedByName || (assignerId ? `User ${assignerId}` : ''),
    };
  }

  static toBackend(data) {
    if (!data) return null;
    const ticketId = Number(data.ticketID ?? data.ticketId ?? data.TicketId ?? data.TicketID ?? 0);
    const userId = Number(data.userID ?? data.userId ?? data.UserId ?? data.UserID ?? 0);
    const assignedBy = Number(data.assignedBy ?? data.AssignedBy ?? 1);
    const assignmentId = Number(data.assignmentID ?? data.assignmentId ?? data.AssignmentId ?? data.AssignmentID ?? data.id ?? 0);
    const nowIso = new Date().toISOString();

    const result = {
      assignmentId,
      ticketId,
      userId,
      assignedBy,
      assignedDttm: data.assignedDttm ? new Date(data.assignedDttm).toISOString() : nowIso,
      isCurrentFlag: data.isCurrentFlag !== undefined
        ? (data.isCurrentFlag === true || data.isCurrentFlag === 'true' || data.isCurrentFlag === 1)
        : true,
    };

    if (data.unassignedDttm) {
      result.unassignedDttm = new Date(data.unassignedDttm).toISOString();
    }

    return result;
  }
}

export default TicketAssignmentModel;

